import { types, initState } from "./types";
import { types as authTypes } from "../auth/types";

const getCompanyUsersReducer = (state = initState, action) => {
  switch (action.type) {
    case types.GET_SOCKET_SUCCESS:
      return {
        ...state,
        socket: action.payload,
      };
    case types.GET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case types.TOGGLE_VIEW_AS_USER:
      return {
        ...state,
        viewAsUser: action.payload,
      };
    case authTypes.LOGIN_SUCCESS:
    case authTypes.LOGIN_QUICK_SUCCESS:
      // Always start a fresh session in the user's primary role (admins land
      // on admin view; players are unaffected). Prevents a stale persisted
      // viewAsUser=true from keeping an admin in player view after re-login.
      return {
        ...state,
        viewAsUser: false,
      };
    default:
      return state;
  }
};

export default getCompanyUsersReducer;
